import {Customer} from '@hconnect/apiclient'
import {startCase, toLower, trim, replace} from 'lodash'

import {WEBHOOK_ENABLED_API_PRODUCTS} from '../../modules/DataScopeConfiguration'
import {GroupedRoleAssignment, RoleType} from '../../modules/ManageUsers.selectors'

export const removeEmptyArraysFromObject = (
  data: Record<string, unknown>
): Record<string, unknown> => {
  // removes keys with [], null,  as value
  // EXAMPLE INPUT: {asdf: []} OUTPUT: {}

  const retval: Record<string, any> = {}

  for (const [key, value] of Object.entries(data)) {
    if (!Array.isArray(value) || value.length > 0) {
      retval[key] = value
    }
  }
  return retval
}

export const prepareAssignRolesPayload = (data: Record<string, any>): Record<string, unknown> =>
  // remove empty arrays, e.g. customerIds, from dataScope
  // {
  //   "dataScope": {
  //     "countryId": "DE",
  //     "orgUnitId": "0093",
  //     "businessLine": "RMC",
  //     "customerIds": []
  //   },
  // }
  // see https://jira.grouphc.net/browse/INC-127

  ({...data, dataScope: removeEmptyArraysFromObject(data.dataScope as Record<string, unknown>)})

export const createEmptyCustomer = (): Customer => ({
  customerId: 'unknown',
  customerName: 'unknown'
})

export const checkRequired =
  (isRequired: boolean, multiSelect: boolean, errorMessage: string) =>
  (value: unknown): string | undefined => {
    if (isRequired && (multiSelect ? !Array.isArray(value) || value.length === 0 : !value)) {
      return errorMessage
    }

    return undefined
  }

export const isProjectsCountry = (countryId: string): boolean => ['AU', 'HK'].includes(countryId)

export const prettyRoleName = (roleType: RoleType): string => {
  const roleTypeWithSpaces = toLower(trim(replace(roleType, /_/g, ' ')))
  return startCase(roleTypeWithSpaces)
}

export const isWebhookSectionVisible = (
  groupedRoleAssignment: Pick<GroupedRoleAssignment, 'commonDataScopes' | 'roleType'>,
  isEditing: boolean,
  webhookEnabledProducts: string[] = WEBHOOK_ENABLED_API_PRODUCTS
): boolean => {
  const apiProduct = groupedRoleAssignment.commonDataScopes.apiProducts
  const selectedProducts = Array.isArray(apiProduct) ? apiProduct : apiProduct ? [apiProduct] : []
  const isWebhookProduct = selectedProducts.some((p) => webhookEnabledProducts.includes(p))
  return (
    !!groupedRoleAssignment.commonDataScopes.webhookSubscriptions ||
    (isEditing && groupedRoleAssignment.roleType === 'DATALINK_INTEGRATION_PARTNER' && isWebhookProduct)
  )
}

export const payerActivatedRoles = [
  'ACCOUNTANT',
  'BUSINESS_OWNER',
  'CONTROLLER',
  'SALES_AGENT',
  'ACCOUNTANT_NOTESTS'
]
